<cx-spinner class="overlay" *ngIf="isOrderLoading"></cx-spinner>
<div class="order-history-list" *ngIf="orderHistoryList?.pagination?.totalResults >= 0">
  <div class="order-history-page-title">
    <h1 class="order-history-title">
      {{ "orderhistory.heading" | cxTranslate}}
      ({{orderHistoryList?.pagination?.totalResults}})
    </h1>

  </div>
  <div class="order-history-header">
    <div class="order-history-daterangepicker-box">
      <label class="order-history-datepicker-label">
        {{ "orderhistory.dateFilterLabel" | cxTranslate}}
      </label>
      <input type="text" placeholder="{{'orderhistory.dateFilterInputPlaceholder' | cxTranslate}}"
        class="order-history-daterangepicker" bsDaterangepicker #dp="bsDaterangepicker" [maxDate]="maxDate"
        [(ngModel)]="daterangepicker" (ngModelChange)="onDateChange($event)" [bsConfig]="bsConfig" />
        <i class="fa fa-calendar" aria-hidden="true"></i>
    </div>
  </div>
  <div class="order-history-table-head hide-sm">
    <div class="order-history-row">
      <div class="order-history-col order-history-col-orderid">
        {{ "orderhistory.orderId" | cxTranslate}}
      </div>
      <div class="order-history-col order-history-col-orderplaced">
        {{ "orderhistory.placedOn" | cxTranslate}}
      </div>
      <div class="order-history-col order-history-col-orderstatus">
        {{ "orderhistory.status" | cxTranslate}}
        <a href="javascript:void(0)" (click)="sortByStatus()">
          <i class="fa fa-sort" aria-hidden="true"></i>
        </a>
      </div>
      <div class="order-history-col order-history-col-ordertype">
        {{ "orderhistory.ordertype" | cxTranslate}}
      </div>
      <div class="order-history-col order-history-col-ordertotal">
        {{ "orderhistory.total" | cxTranslate}}
      </div>

    </div>
  </div>
  <div *ngFor="let order of orderHistoryList.orders">
    <div *ngFor="let item of order.items; let i = index">
      <div class="order-history-row order-history-row-head" *ngIf="item.visibility && i == 0">
        <div class="order-history-col order-history-col-month">
          {{item.month}}
        </div>
      </div>
      <div class="order-history-row order-history-row-body" *ngIf="item.visibility">
        <div class="order-history-col order-history-col-orderid">
          <span class="order-history-col-sm-label hide-md">
            {{ "orderhistory.orderId" | cxTranslate}}:
          </span>
          <a class="order-history-detail-link" (click)="redirectToOrderDeatils(item.code)">{{item.code}}</a>
        </div>
        <div class="order-history-col order-history-col-orderplaced">
          <span class="order-history-col-sm-label hide-md">
            {{ "orderhistory.placedOn" | cxTranslate}}:
          </span>
          {{item.placed | date:'dd MMMM yyyy'}}
        </div>
        <div class="order-history-col order-history-col-orderstatus">
          <span class="order-history-col-sm-label hide-md">
            {{ "orderhistory.status" | cxTranslate}}:
          </span>
          {{item.status | titlecase}}
        </div>
        <div class="order-history-col order-history-col-ordertype">
          <span class="order-history-col-sm-label hide-md">
            {{ "orderhistory.ordertype" | cxTranslate}}:
          </span>
          <span>
            {{item.orderType | titlecase}}
          </span>
        </div>
        <div class="order-history-col order-history-col-ordertotal">
          <span class="order-history-col-sm-label hide-md">
            {{ "orderhistory.total" | cxTranslate}}:
          </span>
          {{item.total.formattedValue}}
        </div>

      </div>
    </div>
  </div>
</div>